export default function ZonesHero() {
  return (
    <section className="relative pt-32 pb-20 overflow-hidden bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=aerial%20panoramic%20view%20of%20Swiss%20Romande%20region%20showing%20Geneva%20Lake%20Leman%20Lausanne%20Vaud%20mountains%20Alps%20beautiful%20landscape%20Switzerland%20French%20speaking%20region%20blue%20sky%20clear%20weather%20professional%20photography%20high%20resolution&width=1920&height=700&seq=zones-hero-suisse-romande&orientation=landscape"
          alt="Suisse Romande vue aérienne"
          className="w-full h-full object-cover object-top opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/80 via-slate-900/60 to-slate-900/90"></div>
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 text-center">
        <div className="inline-flex items-center gap-2 bg-brand-500/20 border border-brand-500/30 rounded-full px-4 py-2 mb-6">
          <i className="ri-map-pin-line text-brand-400 text-sm"></i>
          <span className="text-brand-300 text-sm font-medium">Suisse Romande</span>
        </div>
        <h1 className="text-4xl md:text-6xl font-black text-white mb-6 leading-tight">
          Zones d&apos;Intervention<br />
          <span className="text-brand-400">Suisse Romande</span>
        </h1>
        <p className="text-lg md:text-xl text-white/70 max-w-3xl mx-auto mb-10 leading-relaxed">
          CasaReNovaPlus intervient dans <strong className="text-white">tout le canton de Fribourg</strong> et dans l&apos;ensemble de la <strong className="text-white">Suisse romande</strong> — Berne, Vaud, Valais, Neuchâtel et Jura. Devis gratuit, intervention rapide.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-4">
          <a
            href="tel:+41764803188"
            className="rounded-lg bg-brand-500 px-8 py-4 text-base font-semibold text-white hover:bg-brand-600 transition-all whitespace-nowrap cursor-pointer flex items-center gap-2"
          >
            <i className="ri-phone-line"></i>
            +41 76 480 31 88
          </a>
          <a
            href="tel:+41765654203"
            className="rounded-lg bg-teal-500 px-8 py-4 text-base font-semibold text-white hover:bg-teal-600 transition-all whitespace-nowrap cursor-pointer flex items-center gap-2"
          >
            <i className="ri-phone-line"></i>
            +41 76 565 42 03
          </a>
          <a
            href="/#contact"
            className="rounded-lg bg-white/10 backdrop-blur-sm px-8 py-4 text-base font-semibold text-white border border-white/30 hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer"
          >
            Demander un devis gratuit
          </a>
        </div>
        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto">
          {[
            { icon: 'ri-map-2-line', label: '7 cantons', sub: 'couverts' },
            { icon: 'ri-time-line', label: 'Urgence 24/7', sub: 'disponible' },
            { icon: 'ri-car-line', label: 'Déplacement', sub: 'rapide' },
            { icon: 'ri-price-tag-3-line', label: 'Devis', sub: 'gratuit' },
          ].map((item) => (
            <div key={item.label} className="bg-white/5 border border-white/10 rounded-xl p-4 text-center">
              <div className="w-10 h-10 flex items-center justify-center bg-brand-500/20 rounded-lg mx-auto mb-2">
                <i className={`${item.icon} text-brand-400 text-lg`}></i>
              </div>
              <p className="text-white font-bold text-sm">{item.label}</p>
              <p className="text-white/50 text-xs">{item.sub}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
